import React, { FC, useEffect, useState } from 'react'
import { Box, Text, chakra, HStack, useRadioGroup } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { RadioButtonProps } from '../radio-buttons/interfaces'
import { selectAnswers, selectCurrentAnswers } from '../../state'
import { Steps } from '../../state/interfaces'
import { useSelector } from 'react-redux'
import { getCookie } from '../../scenarios'

interface Choice {
  value: string
  label: string
  image?: string
  isChecked?: boolean
}

export interface RadioButtonGroupProps {
  name: string
  choices: Choice[]
  value?: string
  onChange?: (values: string[]) => void
  component: FC<RadioButtonProps>
}

export const providerAvailability: FC<RadioButtonGroupProps> = ({
  choices,
  value,
  onChange,
  name,
  component: Component,
}) => {
  const currentAnswers = useSelector(selectCurrentAnswers)
  let isDeal = 'false'

  if (currentAnswers[0]) {
    isDeal = currentAnswers[0]
  }

  const { getRadioProps, getRootProps } = useRadioGroup({
    onChange: (value) => onChange && onChange([value, isDeal]),
    value,
    name,
  })

  const [providerAvailable, setProviderAvailable] = useState(false)
  const answers = useSelector(selectAnswers)

  useEffect(() => {
    if (answers[Steps.PROVIDER_AVAILABILITY] && answers[Steps.PROVIDER_AVAILABILITY]![0] === 'true') {
      setProviderAvailable(true)
    }
  }, [answers[Steps.PROVIDER_AVAILABILITY]])

  const { t } = useTranslation()
  const providerName: string | undefined = getCookie('providerName')

  return (
    <Box>
      {providerAvailable ? (
        <Box textAlign={'center'}>
          <Text fontSize="xs" fontWeight="bold" color="green.500" textTransform="uppercase" marginBottom={2}>
            {t('success')}
          </Text>
          <Text fontSize="md" marginBottom={2}>
            {t('provider-available-at', { providerName })}
          </Text>
          <Text fontSize="3xl" fontWeight="bold" marginBottom={2} color="green.500" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![1]}{' '}
            {answers['address-location'] && answers['address-location']![2]}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2} color="green.500" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![3]},{' '}
            <chakra.span textTransform="uppercase">
              {answers['address-location'] && answers['address-location']![4]}{' '}
              {answers['address-location'] && answers['address-location']![6]}
            </chakra.span>
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2} color="green.500" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![5]}
          </Text>
        </Box>
      ) : (
        <Box textAlign={'center'}>
          <Text fontSize="xs" fontWeight="bold" color="error" textTransform="uppercase" marginBottom={2}>
            {t('sorry')}
          </Text>
          <Text fontSize="md" marginBottom={2}>
            {t('provider-not-available-at', { providerName })}
          </Text>
          <Text fontSize="3xl" fontWeight="bold" marginBottom={2} color="error" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![1]}{' '}
            {answers['address-location'] && answers['address-location']![2]}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2} color="error" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![3]},{' '}
            <chakra.span textTransform="uppercase">
              {answers['address-location'] && answers['address-location']![4]}{' '}
              {answers['address-location'] && answers['address-location']![6]}
            </chakra.span>
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2} color="error" textTransform="capitalize">
            {answers['address-location'] && answers['address-location']![5]}
          </Text>
          <Text color="darkGrey" fontSize="xs" marginBottom={9} as="i">
            {t('let-us-notify-you')}
          </Text>
        </Box>
      )}

      <HStack {...getRootProps()} justifyContent="center" margin="2vh">
        {choices.map((props) => (
          <Component key={`choice-${props.value}`} {...getRadioProps({ value: props.value })} {...props} />
        ))}
      </HStack>
    </Box>
  )
}
